import { IncentiveDetailsResponse, IncentivesItemResponse, IncentivesResponse } from '../../lib/types';

export class IncentivesDTO {
	count: number;
	items: IncentiveDTO[];
	groups: Record<'for_you' | 'everyone', IncentiveDTO[]>;

	constructor(data: IncentivesResponse) {
		this.count = data.count;
		this.items = [];
		// based on IncentiveDTO groups
		this.groups = { for_you: [], everyone: [] };

		if (data.items && data.items.length) {
			// ordered amount and if same amount ordered by name
			const orderedByName = data.items.sort((a, b) => a.name.localeCompare(b.name));
			const ordered = orderedByName.sort((a, b) => a.amount - b.amount);
			ordered.forEach((item) => {
				const incentive = new IncentiveDTO(item);
				this.items.push(incentive);
				this.groups[incentive.group].push(incentive);
			});
		}
	}
}
export class IncentiveDTO {
	id: string;
	amount: number;
	amountText: string;
	avatar: string;
	deletedAt: string | null;
	description: string;
	emoji: string;
	isOutOfStock: boolean;
	name: string;
	requireProof: boolean;
	group: 'everyone' | 'for_you';
	state: 'active' | 'inactive';
	stockMessage: string;

	autoApproved: boolean | undefined;
	giverId: string | undefined;
	linkText: string | undefined;
	linkUrl: string | undefined;
	displayReceivingConditions: DisplayReceivingCondition[] | undefined;

	constructor(data: IncentivesItemResponse | IncentiveDetailsResponse) {
		this.id = data.id;
		this.amount = data.amount || 0;
		this.amountText = data.claim_amount;
		this.avatar = data.giver_avatar ?? '';
		this.deletedAt = data.deleted_at;
		this.description = data.description;
		this.emoji = data.emoji_avatar ?? '';
		this.name = data.name;
		this.requireProof = data.require_proof;
		this.state = data.state;
		this.group = data.receivable_by_everyone ? 'everyone' : 'for_you';
		this.isOutOfStock = data.out_of_stock;
		this.stockMessage = data.stock_message;

		// data is IncentiveResponse
		if ('giver_id' in data) {
			this.autoApproved = data.auto_approved;
			this.giverId = data.giver_id;
			this.linkText = data.link_text;
			this.linkUrl = data.link_url;
			this.displayReceivingConditions = data.display_receiving_conditions;
		}
	}

	get isDeleted() {
		return this.deletedAt !== null;
	}

	get isInactive() {
		return this.state === 'inactive';
	}
}

// params for sending an approval request
export interface ApprovalRequestParams {
	id: string;
	attachment?: File;
	giverId?: string;
	reason?: string;
}

export interface DisplayReceivingCondition {
	attr: string;
	value: string;
}
